import {UserJSON} from '../api/types/types';

export function isOnlyMyself(userJSON: UserJSON): boolean {
    const relations = userJSON.relations ?? [];
    if (relations.length === 0) return true;
    return relations.filter((rel) => rel.relationType === 'child').length === 0;
}
